import * as Yup from "yup";

export const logInSchema = Yup.object({
    phone: Yup.string().required("Enter Phone Number"),
    // company: Yup.string().required("Select Company"),
    password: Yup.string().required(" Enter Password"),
});
